import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/flagship/u6-pro.png";
import type { Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u6pro: Product = {
  id: "u6Pro",
  productTitle: "U6 Pro",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u6-pro"],
  storePathParts: { productSlug: "u6-pro", category: "wifi-flagship" },
  sku: "U6-Pro",
  description: "u6Pro.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u6Pro.dimensions",
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6Pro.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "350+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "GbE" },
    },
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IP54" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
